import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { RxPinLeft } from "react-icons/rx";
import { Smartphone } from "lucide-react";
import { useUser } from "../contextProviders/userContext";
import { getNavigation } from "./navigationConfig";
import { OPEN_MOBILE_PROMPT_EVENT } from "./AppShell";

const NavigationGroup = ({ label, items }) => (
  <div className="wcco-nav-group">
    <p className="wcco-nav-label">{label}</p>
    <ul className="wcco-nav-list">
      {items.map(({ to, label: itemLabel, icon: Icon, end }) => (
        <li key={to}>
          <NavLink className="wcco-nav-link" to={to} end={end}>
            <Icon size={18} aria-hidden="true" />
            <span>{itemLabel}</span>
          </NavLink>
        </li>
      ))}
    </ul>
  </div>
);

function Sidebar() {
  const navigate = useNavigate();
  const { user, logout } = useUser();
  const navigation = getNavigation(user?.role);

  const handleLogout = async () => {
    await logout();
    navigate("/signin");
  };

  return (
    <aside className="wcco-sidebar" aria-label="Primary navigation">
      <Link className="wcco-sidebar__brand" to={navigation.home} aria-label="WCCO dashboard">
        <img className="wcco-sidebar__logo" src="/newlogo1.jpg" alt="Wits Citizenship and Community Outreach" />
      </Link>

      <div className="wcco-sidebar__body">
        <nav>
          <NavigationGroup label="Main menu" items={navigation.primary} />
          <NavigationGroup label="Support" items={navigation.secondary} />
        </nav>

        <div className="wcco-sidebar__footer">
          {user?.role === "student" && (
            <button
              className="wcco-mobile-app-btn mb-2"
              type="button"
              onClick={() => window.dispatchEvent(new CustomEvent(OPEN_MOBILE_PROMPT_EVENT))}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                width: "100%",
                padding: "9px 12px",
                border: "1px solid rgba(27, 58, 135, 0.15)",
                borderRadius: "8px",
                backgroundColor: "rgba(27, 58, 135, 0.05)",
                color: "#1B3A87",
                fontSize: "13px",
                fontWeight: 600,
                cursor: "pointer",
                textAlign: "left",
                transition: "all 0.15s ease",
              }}
            >
              <Smartphone size={16} aria-hidden="true" />
              <span>Get Mobile App</span>
            </button>
          )}
          <button className="wcco-signout" type="button" onClick={handleLogout}>
            <RxPinLeft size={18} aria-hidden="true" />
            <span>Sign out</span>
          </button>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
